import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BehaviorSubject } from 'rxjs';
import { AlertService } from '../../../../core/alert.service';
import { CsvImportService } from '../../../services/csv-import.service';

@Component({
  selector: 'app-csv-import-results',
  templateUrl: './csv-import-results.component.html',
  styleUrls: ['./csv-import-results.component.scss'],
})
export class CsvImportResultsComponent implements OnInit {
  busy: boolean = false;
  uploadType: number = 1;
  uploadStep: number = 1;
  processingFile: boolean = false;

  private gridApi;
  private gridColumnApi;

  itemColumns: any[];
  queueResultColumns: any[];
  importItems: any[];

  columns: any[];
  itemsDataSource: any;

  @Input() type: string = ''; // [products,customers,invoices]

  modalTitle: string = 'Completed Imports';
  modalSubTitle: string = 'Here are the list of completed imports';

  constructor(
    private activeModal: NgbActiveModal,
    private csvImportService: CsvImportService,
    private alert: AlertService
  ) {
    this.itemsDataSource = new BehaviorSubject([]);
    this.itemColumns = [
      {
        headerName: 'Name',
        field: 'Name',
        sortable: true,
        filter: true,
        cellRenderer: this.actionRenderer.bind(this),
        width: '300',
      },
      {
        headerName: 'Type',
        field: 'Type',
      },
      {
        headerName: 'Started',
        field: 'StartDate',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Completed',
        field: 'CompletedDate',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Duration (ms)',
        field: 'Duration',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Status',
        field: 'Status',
        sortable: true,
        filter: true,
      },
    ];

    this.queueResultColumns = [
      { headerName: 'Value', field: 'KeyValue' },
      {
        headerName: 'Transaction Type',
        field: 'TransactionType',
        sortable: true,
        filter: true,
      },
      { headerName: 'Result', field: 'Result', sortable: true, filter: true },
      { headerName: 'Message', field: 'Message', sortable: true, filter: true },
    ];
  }

  ngOnInit() {
    this.columns = this.itemColumns;
    this.loadCompletedImports();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout('autoHeight');
    //this.gridApi.sizeColumnsToFit();
  }

  close() {
    this.activeModal.close();
  }

  loadCompletedImports() {
    this.csvImportService.importResults(this.type).subscribe((res) => {
      this.columns = this.itemColumns;
      this.itemsDataSource = res;
    });
  }

  openImportResults(params) {
    this.csvImportService
      .importQueueResults(params.data.Id)
      .subscribe((res) => {
        this.columns = this.queueResultColumns;
        this.itemsDataSource = res;
        this.modalSubTitle =
          'Here are the list of items that are previously imported under ' +
          params.value;
        this.modalTitle = 'Import Results from  ' + params.value;
      });
  }

  private actionRenderer(params) {
    if (params.value) {
      const self = this;
      const eDiv = document.createElement('div');

      let template =
        '<a href="javascript:" class="view-import-result">' +
        params.value +
        '</a>';

      eDiv.innerHTML = template;

      var lnkButton = eDiv.querySelectorAll('.view-import-result')[0];

      lnkButton.addEventListener('click', () => {
        self.openImportResults(params);
      });

      return eDiv;
    }
  }
}
